module.exports = __webpack_public_path__ + "static/tpp-creator01-e77d52d9ea6ab6643810d7d850d8fd77.jpg";